// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"7d62aaa0","106":"7ab8ac1f","181":"f4c2c38e"}[chunkId] + ".chunk.css";
};